import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';
import { useState } from 'react';

export type ForgotPasswordConfirmFormFields = {
  confirmationCode: number;
  newPassword: string;
};

interface ForgotPasswordConfirmFormProps {
  onSubmit: (data: ForgotPasswordConfirmFormFields) => void;
}

export const ForgotPasswordConfirmForm: React.FC<ForgotPasswordConfirmFormProps> = ({
  onSubmit,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control } = useForm<ForgotPasswordConfirmFormFields>({});

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <ControlledInput
        control={control}
        name="confirmationCode"
        rules={{ required: true }}
        inputProps={{ placeholder: 'Confirmation Code', className: 'input-form', fullWidth: true }}
      />

      <div className="password-container">
        <ControlledInput
          control={control}
          name="newPassword"
          rules={{ required: true }}
          inputProps={{
            type: showPassword ? 'text' : 'password',
            placeholder: 'Password',
            className: 'input-form',
            fullWidth: true,
          }}
        />
        <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? '🔒' : '👀'}
        </span>
      </div>
      <button className="login-submit" type="submit">
        Login
      </button>
    </form>
  );
};
